// extracted by mini-css-extract-plugin
export var productImage = "_ja-1";
export var viewLink = "_ja-2";
export var wishlistItem = "_ja-0";